
<div id="primary">

  <ng-content></ng-content>

</div>


